import { render, staticRenderFns } from "./NavbarServcies.vue?vue&type=template&id=4b47967a&scoped=true&"
import script from "./NavbarServcies.vue?vue&type=script&lang=js&"
export * from "./NavbarServcies.vue?vue&type=script&lang=js&"
import style0 from "./NavbarServcies.vue?vue&type=style&index=0&id=4b47967a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b47967a",
  null
  
)

export default component.exports